module.exports = __webpack_public_path__ + "img/toolPic4.a17d879a.png";